// extracted by mini-css-extract-plugin
export default {"container":"styles_container__e4Ygc","formContainer":"styles_formContainer__VodcE","formWrapper":"styles_formWrapper__4pJzh","formContent":"styles_formContent__ms1gF"};